var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 3.75A4.75 4.75 0 0 0 3.75 8.5v7a4.75 4.75 0 0 0 4.75 4.75h7a4.75 4.75 0 0 0 4.75-4.75v-7a4.75 4.75 0 0 0-4.75-4.75zM5.25 8.5A3.25 3.25 0 0 1 8.5 5.25h7a3.25 3.25 0 0 1 3.25 3.25v7a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25zM12 7.75a.75.75 0 0 1 .75.75v2.75h2.75a.75.75 0 0 1 0 1.5h-2.75v2.75a.75.75 0 0 1-1.5 0v-2.75H8.5a.75.75 0 0 1 0-1.5h2.75V8.5a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgAdd;